// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V9H2V2ZM2 11H11L11 22H2V11ZM22 11H13V22H22V11Z","fillRule":"evenodd","clipRule":"evenodd"}}]};

const LayoutFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'layout-filled',
    ref,
    icon: element,
  },
));

LayoutFilledIcon.displayName = 'LayoutFilledIcon';

export default LayoutFilledIcon;
